// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1___33e860e97db36ad00c0","cls2":"ToolsMenu-cls2__d87a01bd2c8424a32963 ToolsMenu-cls1___33e860e97db36ad00c0"};